export class ProcInfoModel {
    code_active: string
    code_category: string
    code_sub_category: string
    brief_history_category: string
    code_fix: string
    procedure_basechg: string
    procedure_tax1: string
    procedure_tax2: string
    procedure_tax3: string
    procedure_response: string
    procedure_sex: string
    code_specie: string
    code_approval: string
    procedure_price: string
    procedure_min_price: string
    procedure_class: string
    codes: string[]
    procedure_comm1: string
    procedure_comm2: string
    procedure_comm3: string
    code_modified_date: string
    link_modified_date: string
    procedure_print: string
    procedure_rescueprice : string 

    constructor(
        code_active: string,
        code_category: string,
        code_sub_category: string,
        brief_history_category: string,
        code_fix: string,
        procedure_basechg: string,
        procedure_tax1: string,
        procedure_tax2: string,
        procedure_tax3: string,
        procedure_response: string,
        procedure_sex: string,
        code_specie: string,
        code_approval: string,
        procedure_price: string,
        procedure_min_price: string,
        procedure_class: string,
        procedure_comm1: string,
        procedure_comm2: string,
        procedure_comm3: string,
        code_modified_date: string,
        link_modified_date: string,
        procedure_print: string,
        procedure_rescueprice:string

    ) {
        this.code_active = code_active
        this.code_category = code_category
        this.code_sub_category = code_sub_category
        this.brief_history_category = brief_history_category
        this.code_fix = code_fix
        this.procedure_basechg = procedure_basechg
        this.procedure_tax1 = procedure_tax1
        this.procedure_tax2 = procedure_tax2
        this.procedure_tax3 = procedure_tax3
        this.procedure_response = procedure_response
        this.procedure_sex = procedure_sex
        this.code_specie = code_specie
        this.code_approval = code_approval
        this.procedure_price = procedure_price
        this.procedure_min_price = procedure_min_price
        this.procedure_class = procedure_class
        this.procedure_comm1 = procedure_comm1
        this.procedure_comm2 = procedure_comm2
        this.procedure_comm3 = procedure_comm3
        this.code_modified_date = code_modified_date
        this.link_modified_date = link_modified_date
        this.procedure_print = procedure_print
        this.procedure_rescueprice = procedure_rescueprice
    }
}